import capitalize from 'lodash/capitalize';
import first from 'lodash/first';

const getStudentFirstAndLastName = (applicant = {}) =>
  `${capitalize(applicant.student.firstName)} ${first(applicant.student.lastName)}`;

export default getStudentFirstAndLastName;
